import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { ModalDirective } from 'ng2-bootstrap/components/modal/modal.component';
import * as moment from 'moment';
import { UtilityFunctions } from '../../shared/utility-functions';


@Component({
  selector: 'booking-log',
  templateUrl: './booking-log-popup.component.html',
  styleUrls: ['./booking-log-popup.component.css'],
  exportAs: 'bookingLog'
})
export class BookingLogPopup implements OnInit {
  @ViewChild('childModal') childModal: ModalDirective;
  private statusOFBookings = [];
  @Output() notify = new EventEmitter<boolean>();
  @Output() showInvoice = new EventEmitter<boolean>();
  constructor(public router: Router) { }
  private successLog = [];
  private errorLog = [];
  public vendor;
  public showPaymentButtons = false;
  @Input() bookingConfirmation = false;
  @Input() isActivityChargable = false;
  ngOnInit() {
  }
  private utilityFunctions = new UtilityFunctions();
  public showChildModal(statusOFBookings, timezoneOffset): void {
    try {
      this.statusOFBookings = statusOFBookings;
      this.successLog = [];
      this.errorLog = [];
      this.configureDataToshow(timezoneOffset);
      this.childModal.config.backdrop = false;
      this.childModal.config.keyboard = false;
      this.vendor = JSON.parse(atob(localStorage.getItem('vendor')));
      this.showPaymentButtons = this.vendor.allowPayment && this.bookingConfirmation;
      this.utilityFunctions.setBackGroundBlack();
      this.childModal.show();
    } catch (e) {
      console.log(e);
    }
  }

  public hideChildModal(): void {
    try {
      this.utilityFunctions.removeBackGroundBlack();
      this.childModal.hide();
    } catch (e) {
      console.log(e);
    }
  }

  onClickOk() {
    try {
      this.notify.emit(true);
    } catch (e) {
      console.log(e);
    }
  }

  onClickCancle() {
    try {
    } catch (e) {
      console.log(e);
    }
  }

  configureDataToshow(timezoneOffset) {
    let that = this;
    //start time
    this.statusOFBookings = this.statusOFBookings.filter(function (rec: any) {
      let startHours = moment(rec.startTime).utcOffset(timezoneOffset).hour();
      let startMinutes = moment(rec.startTime).utcOffset(timezoneOffset).minutes();
      rec.startMinutes = startMinutes < 10 ? "0" + startMinutes : startMinutes;
      //hours + minutes
      rec.start = startHours < 10 ? "0" + startHours : startHours;
      rec.start = rec.start + ':' + rec.startMinutes;

      //end time
      let endHours = moment(rec.endTime).utcOffset(timezoneOffset).hour();
      let endMinutes = moment(rec.endTime).utcOffset(timezoneOffset).minutes();
      rec.endMinutes = endMinutes < 10 ? "0" + endMinutes : endMinutes;
      rec.end = moment(rec.endTime).utcOffset(timezoneOffset).hour();
      //hour + minutes
      rec.end = endHours < 10 ? "0" + endHours : endHours;
      rec.end = rec.end + ":" + rec.endMinutes;
      rec.bookingDate = moment(rec.startTime).utcOffset(timezoneOffset).format('ll');
      if (rec.status) {
        that.successLog.push(rec)
      } else {
        that.errorLog.push(rec);
      }
      return rec;
    });
  }

  payNow() {
    this.showInvoice.emit(false);
    this.hideChildModal();
  }
}



// WEBPACK FOOTER //
// ./src/app/primecalendar/booking-log-popup/booking-log-popup.component.ts